import React, { useEffect, useState, useRef } from "react";
import axios from '../../../plugins/axios'
import moment from 'moment';
import { useTranslation } from "react-i18next"
import { useRecoilState } from 'recoil';
import { selectBedInfoState,wardState } from '../../../plugins/recoil';
import {ReactComponent as IconArrowUp} from '../../../assets/icons/ic-arrow-up.svg'
import {ReactComponent as IconArrowDown} from '../../../assets/icons/ic-arrow-down.svg'
import {ReactComponent as IconCheck} from '../../../assets/icons/ic-check_blue.svg';
import { heightUnitConvert, weightUnitConvert} from '../../../plugins/common';
import Toast from '../../../plugins/useToast';

const initialPatientInfo = {
  displayDevicePatientId: true,
  devicePatientId: '',
  displayName: true,
  name: '',
  birthDate: '',
  gender: '',
  category: '',
  height: '',
  weight: '',
  phoneNumber: '',
  address: '',
  protectorName: '',
  protectorPhoneNumber: '',
  room: '',
  doctor1: {
    doctorName: '',
    doctorPhoneNumber: ''
  },
  doctor2: {
    doctorName: '',
    doctorPhoneNumber: ''
  },
  nurse1: {
    nurseName: '',
    nursePhoneNumber: ''
  },
  nurse2: {
    nurseName: '',
    nursePhoneNumber: ''
  },
  nurse3: {
    nurseName: '',
    nursePhoneNumber: ''
  }
};

const inputClasses = "w-[256px] h-[32px] bg-[#383838] px-[8px] rounded-[6px] block border border-[#4E4E4E] box-border font-light";
const radioInputClasses = "w-[250px] h-[32px] bg-[#383838] px-2 block border border-[#4E4E4E] box-border font-light bg-gradient-to-b from-[#DEDEDE] to-[#9F9F9F] text-black hover:!border-[rgba(255,255,255,0.60)]";
const labelClasses = "font-[300] mb-[6px] inline-block text-[#8C8C8C] opacity-70";

function PatientInfoSettings({deviceInfo ,handleConfirm ,handleDeviceDataChange, onClose ,handleSaveParameter,handleConfirmTransfer,handleSaveSuccess,deviceModelMenus}) {
    const { t } = useTranslation()
    const [ward,setWard] = useState(null);   
    const [selectBedInfo, setSelectBedInfo] = useRecoilState(selectBedInfoState)
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);    
    const [isDisabled, setIsDisabled] = useState(true);    
    const [categorys, ] = useState([{value : 'ADULT', label : 'Adult'}, {value : 'PEDIATRIC', label : 'Pediatric'}, {value : 'NEONATAL', label : 'Neonatal'}, {value : 'NONE', label : 'NONE'}]); //카테고리
    const [selectInfo, setSelectInfo] = useState({ //select box 전용으로 세팅하는중.
        gender: 'M',
        category: 'ADULT',
    })        
    const [isAdmit, setIsAdmit] = useState(false);            
    const [patientData, setPatientData] = useState({});
    const [originalPatientData, setOriginalPatientData] = useState({}); //최초 원본 환자 데이터
    const [patientUnit, setPatientUnit] = useState({weight : 'kg', height : 'cm'});    
    const [isModify, setIsModify] = useState(); 
    const standbyModeRef = useRef(null);

    //input 값 변경 시 환자 데이터 업데이트
    const handleValueChange = (field, value) => {
        if (field.includes('.')) {
            const [parent, child] = field.split('.');
            setPatientData(prev => ({
                ...prev,
                [parent]: {
                    ...prev[parent],
                    [child]: value,
                }
            }));
        } else {
            setPatientData(prev => ({
                ...prev,
                [field]: value,
            }));
        }
        setIsDisabled(false);        
    };    

    //to-be : Admit 환자 저장 (최초 입원 시)
    const handleSave = async (type) => {
        try {            
            //Name Check / Patient ID Check가 둘중 하나 안되어있으면 저장 안되게 수정. 
            if(!patientData.displayName && !patientData.displayDevicePatientId) {
                Toast({ isSuccess: false, msg: t('bedSetting.noEmptyPatientNameId') });
                return;
            }
            
            // Admit 시 환자 Name, Patient ID가 없으면 아래 기본값으로 설정
            // Name : Unknown 
            // Patient ID : PI_yymmddhhmmss 으로 표기 (년 앞자리 2개는 제거)
            let name = patientData.name;
            let devicePatientId = patientData.devicePatientId;
            if (type === 'admit') {
                if (!name) name = 'Unknown';
                if (!devicePatientId) {                    
                    devicePatientId = `PI_${moment().format('YYMMDDHHmmss')}`;
                }
            }

            const payloadPatientData = {}
            Object.keys(patientData).forEach(key => {
                if (patientData[key] === null) {
                    if (['doctor1', 'doctor2'].includes(key)) {
                        payloadPatientData[key] = { doctorName: '', doctorPhoneNumber: '' };
                    } else if (['nurse1', 'nurse2', 'nurse3'].includes(key)) {
                        payloadPatientData[key] = { nurseName: '', nursePhoneNumber: '' };
                    } else {
                        payloadPatientData[key] = '';
                    }
                } else {
                    payloadPatientData[key] = patientData[key];
                }
            });

            // ✅ height와 weight를 cm/kg로 변환
            if (patientUnit?.height === 'in' && payloadPatientData.height) {
                payloadPatientData.height = heightUnitConvert(payloadPatientData.height, 'cm');
            }

            if (patientUnit?.weight === 'lb' && payloadPatientData.weight) {
                payloadPatientData.weight = weightUnitConvert(payloadPatientData.weight, 'kg');
            }

            const payload = {
                ...payloadPatientData,
                name,
                devicePatientId,
                gender: selectInfo.gender,
                category: selectInfo.category,                
            }; 

            let res;
            if(type == 'admit'){                
                payload.deviceId = selectBedInfo.deviceId;
                res =  await axios.post('/patient', payload);
                if (res.code != '200') throw res
                handleDeviceDataChange(res.data.id);
            }else if(type == 'modify'){                          
                res =  await axios.put(`/patient/${payload.id}`, payload);
                if (res.code != '200') throw res
                getPatientData(res.data.id);
                setIsDisabled(true); //수정 후 저장 버튼 비활성화
            }            

            //Display Name, Patient ID, Name 변경 시 selectBedInfo 업데이트
            setSelectBedInfo(prev => ({
                ...prev,
                displayDevicePatientId: res.data.displayDevicePatientId,
                devicePatientId: devicePatientId,
                displayName: res.data.displayName,
                patientName: name,
                patientId : res.data.id,
                nameDisplay: devicePatientId && name ? '3' : devicePatientId ? '2' : '1',
            }));
            
            handleSaveParameter();
            Toast({ isSuccess: true });                  
        } catch (error) {            
            // 409 Conflict
            if (error.status === 409) {                
                Toast({ isSuccess: false, msg: t('bedSetting.ErrorConflict') });
            } else if (error.code === 1000) {
                Toast({ isSuccess: false, msg: `Error: ${error.message}` });
            } else {
                Toast({ isSuccess: false, msg: `Error: ${error.message || error}` });        
            }
        }
    }

    //#region - **confirm layer popup zone**
    //입원
    const handleAdmitConfirm = () => {
        handleConfirm(t('bedSetting.admit'),t('bedSetting.admitConfirm'),handleAdmitYes,handleAdmitNo);
    }

    //입원 Yes
    const handleAdmitYes = () => {
        handleSave('admit');
    }

    //입원 No
    const handleAdmitNo = () => {
        console.log('No Clicked');
    }

    //Discharge Confirm button
    const handleDisChargeConfirm = () => {
        handleConfirm(t('bedSetting.discharge'),t('bedSetting.dischargeConfirm', { patientName: patientData.name }),handleDisChargeYes,handleDisChargeNo);
    }

    //퇴원 Yes
    const handleDisChargeYes = async () => {
        try {
            const payload = {
                status: "UNASSIGNED"
            }
            const res = await axios.patch(`/patient/${deviceInfo.patientId}/status`,payload);
            if (res.code != '200') throw res            

            setSelectBedInfo(prev => ({
                ...prev,
                displayDevicePatientId: '',
                devicePatientId: '',
                displayName: '',
                patientName: '',
                nameDisplay: '1',
                patientId : null
            }));

            handleSaveParameter();
            Toast({ isSuccess: true, msg: t('bedSetting.dischargeSuccess') });
            handleDeviceDataChange(null);
        } catch (err) {
            console.warn(err)
        }
    }

    //퇴원 No
    const handleDisChargeNo = () => {   
        console.log('No Clicked');
    }

    //Transfer Confirm button
    const handleTransferConfirm = () => {
        //console.log('selectBedInfo : ', selectBedInfo);
        const patientInfo = {            
            ward : { value : ward.id || '', label : ward.name || ''},
            device : { value : selectBedInfo.deviceId || '', label : selectBedInfo.bedNumber || '', serial : selectBedInfo.serial || ''},            
            PatientName : originalPatientData.name || '',
            PatientId : originalPatientData.devicePatientId || '',
            transferId : originalPatientData.id || '',
        }

        handleConfirmTransfer(patientInfo);        
    }
    //#endregion - **confirm layer popup zone**

    //stand by 모드 세팅
    const handleSetStandby = async () => {
        //DB 상에서 Standby 모드로 세팅하고 넘어가야 됨.
        try {
            const payload = {
                standbyMode: true
            }
            const res = await axios.patch(`/device/${deviceInfo.id}/standby`,payload);
            if (res.code != '200') throw res            

            Toast({ isSuccess: true, msg: t('bedSetting.standbySuccess') });
            await handleSaveParameter(); //동기식으로 수정. (기존에 비동기식으로 처리되어서 문제가 발생함)
            onClose();
        }catch(err){
            console.warn(err)
        }
    }    

    const getPatientData = async (patientId) => {
        try {
            //Ward 정보 가져오기            
            const wardRes = await axios.get(`/ward/${deviceInfo.wardId}`);
            if (wardRes.code != '200') throw wardRes

            setWard(wardRes.data);
            
            //Patient 기본 단위 정보 가져오기
            const patientInfoRes = await axios.get('/system/patient/unit/default')
            if (patientInfoRes.code != '200') throw patientInfoRes
            const patientInfo = patientInfoRes.data;

            setPatientUnit({
                weight : patientInfo.weightUnit || 'kg',
                height : patientInfo.heightUnit || 'cm'
            })

            if(patientId){
                const res = await axios.get(`/patient/${patientId}`);
                if (res.code != '200') throw res                

                setPatientData({
                    ...res.data,
                    height: patientInfo.heightUnit === 'in' && res.data.height 
                        ? heightUnitConvert(res.data.height, 'in') 
                        : res.data.height,
                    weight: patientInfo.weightUnit === 'lb' && res.data.weight 
                        ? weightUnitConvert(res.data.weight, 'lb') 
                        : res.data.weight
                });

                setOriginalPatientData(res.data); //원본 데이터 저장
                setIsAdmit(res.data.status == 'ADMITTED' ? true : false);      
                setSelectInfo({
                    gender : res.data.gender || 'M',
                    category : res.data.category || 'ADULT',
                })                
            }else {
                //더미 데이터 넣기
                setPatientData(initialPatientInfo);
                setIsAdmit(false)
            }
        } catch (err) {
            setPatientData(initialPatientInfo);
            setIsAdmit(false);
            console.warn(err)
        }
    }    

    //select box 밖에 눌렀을 때 창 닫기
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest('.select-dropdown')) {
                setIsDropdownOpen(null);
            }
        };
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [patientData.length]);      

    //최초 랜더 되었을 때 설정    
    useEffect(() => {                 
        if(deviceInfo){                 
            getPatientData(deviceInfo?.patientId); //환자 데이터 가져오기                        
            const isModify = deviceModelMenus.find(item => item.model === deviceInfo.deviceModel)?.patientInfoModify;            
            const isStandbyMode = deviceModelMenus.find(item => item.model === deviceInfo.deviceModel)?.standbyModeSupported;
            standbyModeRef.current = isStandbyMode;
            setIsModify(isModify);            
        }        
    }, [deviceInfo]);

    //UseState 변경 체크 Test
    // useEffect(() => {
    //   console.log('Patient Data Updated:', patientData);
    // }, [patientData]) 
    
    // useEffect(() => {
    //   console.log('selectBedInfo:', selectBedInfo);
    // }, [selectBedInfo]) 

    const styleDisabled = '!bg-[#282828] text-[rgba(255,255,255,0.2)] !cursor-default shadow-none !border-none';

    return (
        <div className="relative w-full h-full">
            <div className="flex overflow-y-auto scrollbar" style={{ height: 'calc(100%)' }}>
                <div className="h-[488px] p-[15px] text-[#DEDEDE] box-border">
                    <div className="flex">
                        <div className="h-[448px] border-r border-[#4E4E4E] pr-[40px]">
                            <div className="flex gap-[16px]">
                                <div>
                                    <p className="mb-[16px] text-[18px] font-normal leading-[110%]">{t('bedSetting.patientInfo')}</p>
                                    <label className={`${labelClasses}`}>{t('bedSetting.displayedName')}</label> 
                                </div>
                            </div>
                            <div className="flex gap-[4px] mb-[12px] bg-[#383838] rounded-[8px] p-[4px]">                                                                
                                <div className={`bg-black rounded-[6px] p-[6px] w-[258px] ${!isModify ? styleDisabled : ''}`}
                                    style={!isModify ? null : patientData.displayName ? {
                                        backgroundColor: 'rgba(49, 130, 247, 0.20)',
                                        boxShadow: 'inset 0 0 0 1px #3182F7'
                                    } : null}>
                                    <label className="flex gap-[4px]">
                                        <input
                                            type="checkbox"
                                            checked={!!patientData.displayName} 
                                            className={`${!isModify ? styleDisabled : ''}`}
                                            disabled={!isModify}                                              
                                            onChange={e => handleValueChange('displayName', e.target.checked)}                                            
                                        />
                                        <span className="mb-[6px] font-light">{t('bedSetting.name')}</span>
                                    </label>
                                    <input
                                        type="text"
                                        value={patientData.name || ''}
                                        disabled={!isModify}
                                        onChange={(e) => {
                                            const filteredValue = e.target.value.replace(/[^a-zA-Z0-9\s!@#$%^&*()_-]/g, '');
                                            handleValueChange('name', filteredValue)
                                        }}
                                        maxLength={40}
                                        className={`${inputClasses} !w-[250px] ${!isModify ? '!border-none' : ''}`}
                                    />
                                </div>                                
                                <div className={`bg-black rounded-[4px] p-[6px] w-[258px] ${!isModify ? styleDisabled : ''}`}
                                    style={!isModify ? null : patientData.displayDevicePatientId ? {
                                        backgroundColor: 'rgba(49, 130, 247, 0.20)',
                                        boxShadow: 'inset 0 0 0 1px #3182F7'
                                    } : null}>
                                    <label className="flex gap-[4px]">
                                        <input
                                            type="checkbox"
                                            checked={!!patientData.displayDevicePatientId}
                                            className={`${!isModify ? styleDisabled : ''}`}
                                            disabled={!isModify}  
                                            onChange={e => handleValueChange('displayDevicePatientId', e.target.checked)}                                            
                                        />
                                        <span className="mb-[6px] font-light">{t('bedSetting.patientId')}</span>
                                    </label>
                                    <input
                                        type="text"
                                        value={patientData.devicePatientId || ''}
                                        onChange={(e) => {
                                            const filteredValue = e.target.value.replace(/[^a-zA-Z0-9\s!@#$%^&*()_-]/g, '');
                                            handleValueChange('devicePatientId', filteredValue)
                                        }}
                                        disabled={!isModify}
                                        maxLength={40}
                                        className={`${inputClasses} !w-[250px] ${!isModify ? '!border-none' : ''}`}
                                    />
                                </div>
                            </div>                                                  

                            <div className="flex gap-[16px]">
                                <div className="mb-[12px]">
                                    <label className={`${labelClasses}`}>{t('bedSetting.category')}</label>
                                    <div className="relative select-dropdown">
                                        <div className={`${!isModify ? styleDisabled : ''} bg-[#383838] text-[#DEDEDE] w-[256px] h-[32px] px-[8px] rounded-[6px] cursor-pointer flex items-center justify-between border border-[#4E4E4E]`}
                                        onClick={(e) => { e.stopPropagation(); isModify && setIsDropdownOpen('Category');}}>
                                            <div className="w-[200px]">{`${t(`bedSetting.${categorys.find(c => c.value === selectInfo.category)?.label.toLowerCase()}`)}` || ''}</div>
                                            <div className={`${!isModify ? 'hidden' : '' } pointer-events-none`}>
                                                {isDropdownOpen === 'Category' ? <IconArrowUp /> : <IconArrowDown />}
                                            </div>
                                        </div>
                                        {isDropdownOpen === 'Category' && (
                                            <div className="gender-dropdow absolute top-[35px] bg-[#1F1F1F] w-[256px] py-[8px] rounded-[6px] border border-[#5E5E5E] shadow-[0px_12px_12px_0px_rgba(0,0,0,0.4)] z-20">                                            
                                                {categorys.map((category, _) => {
                                                    return (
                                                        <div                                                             
                                                            key={`${category.value}`}
                                                            className={`bg-[#1F1F1F] cursor-pointer h-[32px] flex items-center justify-between px-[8px] hover:bg-[#2F2F2F] 
                                                            ${category.value === selectInfo.category ? "text-[#3182F7]" : "text-white"}`}                                                            
                                                            onClick={() => { setIsDropdownOpen(null); setSelectInfo(prev => ({ ...prev, category : category.value })); setIsDisabled(false); }}>                                                                
                                                            {t(`bedSetting.${category.label.toLowerCase()}`)}                                                            
                                                            {category.value === selectInfo.category && (
                                                                <IconCheck className="w-4 h-4 ml-2" />
                                                            )}
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        )}
                                    </div>
                                </div>                                    
                                <div className="mb-[12px]">
                                    <label className={`${labelClasses}`}>{t('bedSetting.gender')}</label>
                                    <div className="relative select-dropdown">
                                        <div className={`${!isModify ? styleDisabled : ''} bg-[#383838] text-[#DEDEDE] w-[256px] h-[32px] px-[8px] rounded-[6px] cursor-pointer flex items-center justify-between border border-[#4E4E4E]`}
                                        onClick={(e) => { e.stopPropagation(); isModify && setIsDropdownOpen('Gender');}}>
                                            <div className="w-[200px]">{selectInfo.gender === "M" ? t('bedSetting.male') : selectInfo.gender === "F" ? t('bedSetting.female') : t('bedSetting.none')}</div>
                                            <div className={`${!isModify ? 'hidden' : '' } pointer-events-none`}>
                                                {isDropdownOpen === 'Gender' ? <IconArrowUp /> : <IconArrowDown />}
                                            </div>
                                        </div>
                                        {isDropdownOpen === 'Gender' && (
                                            <div className="gender-dropdow absolute top-[35px] bg-[#1F1F1F] w-[256px] py-[8px] rounded-[6px] border border-[#5E5E5E] shadow-[0px_12px_12px_0px_rgba(0,0,0,0.4)] z-20">
                                                <div className={`bg-[#1F1F1F] cursor-pointer h-[32px] flex items-center justify-between px-[8px] hover:bg-[#2F2F2F] 
                                                    ${selectInfo.gender === "M" ? "text-[#3182F7]" : "text-white"}`}
                                                    onClick={(e) => { e.stopPropagation(); setSelectInfo(prev => ({ ...prev, gender: 'M' })); setIsDropdownOpen(null); setIsDisabled(false); }}>
                                                    {t('bedSetting.male')}
                                                    {selectInfo.gender === "M" && (
                                                        <IconCheck className="w-4 h-4 ml-2" />
                                                    )}
                                                </div>
                                                <div className={`bg-[#1F1F1F] cursor-pointer h-[32px] flex items-center justify-between px-[8px] hover:bg-[#2F2F2F]
                                                    ${selectInfo.gender === "F" ? "text-[#3182F7]" : "text-white"}`}
                                                    onClick={(e) => { e.stopPropagation(); setSelectInfo(prev => ({ ...prev, gender: 'F' })); setIsDropdownOpen(null); setIsDisabled(false); }}>
                                                    {t('bedSetting.female')}
                                                    {selectInfo.gender === "F" && (
                                                        <IconCheck className="w-4 h-4 ml-2" />
                                                    )}
                                                </div>
                                                <div className={`bg-[#1F1F1F] cursor-pointer h-[32px] flex items-center justify-between px-[8px] hover:bg-[#2F2F2F]
                                                    ${selectInfo.gender === "N" ? "text-[#3182F7]" : "text-white"}`}
                                                    onClick={(e) => { e.stopPropagation(); setSelectInfo(prev => ({ ...prev, gender: 'N' })); setIsDropdownOpen(null); setIsDisabled(false); }}>
                                                    {t('bedSetting.none')}
                                                    {selectInfo.gender === "N" && (
                                                        <IconCheck className="w-4 h-4 ml-2" />
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="flex gap-[16px]">
                                <div className="mb-[12px] relative">
                                    <label className={`${labelClasses}`}>{t('bedSetting.height')}</label>
                                    <input
                                        type="text"
                                        value={patientData.height || ''}                                        
                                        onChange={(e) => {
                                            let value = e.target.value
                                                .replace(/[^0-9.]/g, '') // 숫자와 점만 허용
                                                .replace(/(\..*)\./g, '$1'); // 점이 두 번 이상 들어가는 경우 첫 번째 점 이후의 점은 제거
                                            handleValueChange('height', value);
                                        }}
                                        onBlur={(e) => {
                                            let value = e.target.value;                                            
                                            if (value.startsWith('.') && value.length > 1) {
                                                value = value.slice(1);
                                                value = value[0] + '.' + value.slice(1);
                                            }
                                            // 점이 맨 뒤에 있으면 점 삭제
                                            if (value.endsWith('.')) {
                                                value = value.slice(0, -1);
                                            }
                                            handleValueChange('height', value);
                                        }}
                                        className={`${inputClasses} ${!isModify ? styleDisabled : ''} pr-10 !w-[256px]`}
                                        maxLength={7}
                                        disabled={!isModify}
                                    />
                                    <span className={`${!isModify ? 'text-[rgba(255,255,255,0.2)]' : ''} ml-2 absolute bottom-[6px] right-2`}>{patientUnit?.height}</span>
                                </div>
                                <div className="mb-[12px] relative">
                                    <label className={`${labelClasses}`}>{t('bedSetting.weight')}</label>
                                    <input
                                        type="text"
                                        value={patientData.weight || ''}
                                        onChange={(e) => {
                                            let value = e.target.value
                                                .replace(/[^0-9.]/g, '')
                                                .replace(/(\..*)\./g, '$1');
                                            handleValueChange('weight', value);
                                        }}
                                        onBlur={(e) => {
                                            let value = e.target.value;                                            
                                            if (value.startsWith('.') && value.length > 1) {
                                                value = value.slice(1);
                                                value = value[0] + '.' + value.slice(1);
                                            }
                                            // 점이 맨 뒤에 있으면 점 삭제
                                            if (value.endsWith('.')) {
                                                value = value.slice(0, -1);
                                            }
                                            handleValueChange('weight', value);
                                        }}
                                        className={`${inputClasses} ${!isModify ? styleDisabled : ''} pr-10 !w-[256px]`}
                                        maxLength={7}
                                        disabled={!isModify}
                                    />
                                    <span className={`${!isModify ? 'text-[rgba(255,255,255,0.2)]' : ''} ml-2 absolute bottom-[6px] right-2`}>{patientUnit?.weight}</span>
                                </div>
                            </div>      

                            <div className="flex gap-[16px]">
                                <div className="mb-[12px]">
                                    <label className={`${labelClasses}`}>{t('bedSetting.dateOfBirth')}</label>
                                    <input
                                        type="text"
                                        className={`${inputClasses} ${!isModify ? styleDisabled : ''} !w-[256px] placeholder:text-[#8C8C8C] focus:placeholder:text-[transparent]`}
                                        placeholder="YYYY-MM-DD"
                                        value={patientData.birthDate || ''}
                                        onChange={(e) => {
                                            // 숫자만 허용
                                            const rawValue = e.target.value.replace(/[^0-9]/g, '');
                                            setPatientData((prev) => ({
                                                ...prev,
                                                birthDate: rawValue, // 포맷 없이 숫자만 업데이트
                                            }));
                                            setIsDisabled(false); // 저장 버튼 활성화
                                        }}
                                        onBlur={(e) => {
                                            const rawValue = e.target.value.replace(/[^0-9]/g, '');
                                            if (rawValue.length === 8) {
                                                const year = parseInt(rawValue.slice(0, 4), 10);
                                                const month = parseInt(rawValue.slice(4, 6), 10);
                                                const day = parseInt(rawValue.slice(6, 8), 10);

                                                // 날짜 유효성 검사
                                                const date = new Date(year, month - 1, day); // 월은 0부터 시작
                                                if (
                                                    date.getFullYear() === year &&
                                                    date.getMonth() === month - 1 &&
                                                    date.getDate() === day
                                                ) {
                                                    // 올바른 날짜 형식으로 반영
                                                    const formattedValue = `${year.toString().padStart(4, '0')}-${month
                                                        .toString()
                                                        .padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
                                                    setPatientData((prev) => ({
                                                        ...prev,
                                                        birthDate: formattedValue,
                                                    }));
                                                    return;
                                                }
                                            }
                                            // 유효하지 않은 날짜는 빈 값으로 처리
                                            setPatientData((prev) => ({
                                                ...prev,
                                                birthDate: '',
                                            }));
                                        }}
                                        maxLength={8}
                                        disabled={!isModify}
                                    />
                                </div>
                                <div className="mb-[12px]">
                                    <label className={`${labelClasses}`}>{t('bedSetting.phoneNumber')}</label>
                                    <input
                                        type="text"
                                        value={patientData.phoneNumber || ''}
                                        onChange={(e) => handleValueChange('phoneNumber', e.target.value)}
                                        className={`${inputClasses} ${!isModify ? styleDisabled : ''} !w-[256px]`}
                                        maxLength={20}
                                        disabled={!isModify}
                                    />
                                </div>
                            </div>

                            <div className="mb-[12px]">
                                <label className={`${labelClasses}`}>{t('bedSetting.address')}</label>
                                <input
                                    type="text"
                                    value={patientData.address || ''}
                                    onChange={(e) => handleValueChange('address', e.target.value)}
                                    className={`${inputClasses} ${!isModify ? styleDisabled : ''} w-[528px]`}
                                    maxLength={200}
                                    disabled={!isModify}
                                />
                            </div>
                        </div>

                        
                            
                        {/* Emergency contact & Patient Care Info */}
                        <div className="border-r border-[#4E4E4E] px-[40px]">
                            <h2 className="text-lg mb-[16px] font-normal text-white">{t('bedSetting.emergencyContact')}</h2>
                            <div className="mb-[18px]">
                                <label className={`${labelClasses}`}>{t('bedSetting.name')}</label>
                                <input
                                    type="text"
                                    value={patientData.protectorName || ''}
                                    onChange={(e) => handleValueChange('protectorName', e.target.value)}
                                    className={`${inputClasses} ${!isModify ? styleDisabled : ''}`}
                                    maxLength={40}
                                    disabled={!isModify}
                                />
                            </div>
                            <div className="flex gap-[16px]">
                                <div className="mb-[18px]">
                                    <label className={`${labelClasses}`}>{t('bedSetting.phoneNumber')}</label>
                                    <input
                                        type="text"
                                        value={patientData.protectorPhoneNumber || ''}
                                        onChange={(e) => handleValueChange('protectorPhoneNumber', e.target.value)}
                                        className={`${inputClasses} ${!isModify ? styleDisabled : ''} !w-[256px]`}
                                        maxLength={20}
                                        disabled={!isModify}
                                    />
                                </div>
                            </div>
                            
                            <h2 className="text-lg mb-[16px] font-normal text-white">{t('bedSetting.patientCareInfo')}</h2>
                            <div className="flex gap-[16px]">
                                <div className="mb-[18px]">
                                    <label className={`${labelClasses}` }>{t('bedSetting.ward')}</label>
                                    <div className="relative">
                                        <div className={`text-[#DEDEDE] w-[120px] h-[32px] px-[8px] rounded-[6px] flex items-center justify-between !bg-[#282828] text-[rgba(255,255,255,0.2)] !cursor-default shadow-none`}>                                            
                                            <div
                                                style={{
                                                    width: '200px',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap',
                                                }}
                                                title={ward?.name}
                                            >
                                                {ward?.name}
                                            </div>
                                        </div>                                        
                                    </div>
                                </div>
                                <div className="mb-[18px]">
                                    <label className={`${labelClasses}`}>{t('bedSetting.bedNo')}</label>
                                    <div className="relative">                                        
                                        <div className={`text-[#DEDEDE] w-[120px] h-[32px] px-[8px] rounded-[6px] flex items-center justify-between !bg-[#282828] text-[rgba(255,255,255,0.2)] !cursor-default shadow-none`}>
                                            <div className="w-[200px]">{selectBedInfo?.bedNumber}</div>                                            
                                        </div>                                        
                                    </div>                                    
                                </div>
                            </div>
                            <div className="flex gap-[16px]">
                                <div className="mb-[12px]">
                                <label className={`${labelClasses}`}>{t('bedSetting.equipment')}</label>
                                    <input
                                        type="text"
                                        value={deviceInfo?.deviceModel || '' }                                        
                                        className={`${inputClasses} !w-[120px] cursor-default !bg-[#282828] !text-[rgba(255,255,255,0.2)] shadow-none border-none hover:!border-none`}
                                        readOnly
                                        disabled
                                    />
                                </div>
                                <div className="mb-[12px]">
                                    <label className={`${labelClasses}`}>{t('bedSetting.room')}</label>
                                    <input
                                        type="text"
                                        value={patientData.room || ''}
                                        onChange={(e) => handleValueChange('room', e.target.value)}
                                        className={`${inputClasses} ${!isModify ? styleDisabled : ''} !w-[120px]`}
                                        maxLength={5}
                                        disabled={!isModify}
                                    />
                                </div>
                            </div>
                        </div>
                
                        {/* Medical Staff */}
                        <div className="h-[448px] border-r border-[#4E4E4E] px-[40px]">
                            <h2 className="text-lg mb-[16px] font-normal text-white">{t('bedSetting.medicalStaff')}</h2>
                            <div className="flex gap-[16px]">
                                <div className="mb-[18px]">
                                    <label className={`${labelClasses}`}>{`${t('bedSetting.doctor')} 1`}</label>
                                    <input
                                        type="text"
                                        value={patientData.doctor1?.doctorName || ''}
                                        onChange={(e) => handleValueChange('doctor1.doctorName', e.target.value)}
                                        className={`${inputClasses} ${!isModify ? styleDisabled : ''}`}
                                        maxLength={40}
                                        disabled={!isModify}
                                    />
                                </div>
                                <div className="mb-[18px]">
                                    <label className={`${labelClasses}`}>{`${t('bedSetting.doctor')} 1 - ${t('bedSetting.phoneNumber')}`}</label>
                                    <input
                                        type="text"
                                        value={patientData.doctor1?.doctorPhoneNumber || ''}
                                        onChange={(e) => handleValueChange('doctor1.doctorPhoneNumber', e.target.value)}
                                        className={`${inputClasses} ${!isModify ? styleDisabled : ''}`}
                                        maxLength={20}
                                        disabled={!isModify}
                                    />
                                </div>
                            </div>
                            <div className="flex gap-[16px]">
                                <div className="mb-[18px]">
                                    <label className={`${labelClasses}`}>{`${t('bedSetting.doctor')} 2`}</label>
                                    <input
                                        type="text"
                                        value={patientData.doctor2?.doctorName || ''}
                                        onChange={(e) => handleValueChange('doctor2.doctorName', e.target.value)}
                                        className={`${inputClasses} ${!isModify ? styleDisabled : ''}`}
                                        maxLength={40}
                                        disabled={!isModify}
                                    />
                                </div>
                                <div className="mb-[18px]">
                                    <label className={`${labelClasses}`}>{`${t('bedSetting.doctor')} 2 - ${t('bedSetting.phoneNumber')}`}</label>
                                    <input
                                        type="text"
                                        value={patientData.doctor2?.doctorPhoneNumber || ''}
                                        onChange={(e) => handleValueChange('doctor2.doctorPhoneNumber', e.target.value)}
                                        className={`${inputClasses} ${!isModify ? styleDisabled : ''}`}
                                        maxLength={20}
                                        disabled={!isModify}
                                    />
                                </div>
                            </div>
                            <div className="flex gap-[16px]">
                                <div className="mb-[18px]">
                                    <label className={`${labelClasses}`}>{`${t('bedSetting.nurse')} 1`}</label>
                                    <input
                                        type="text"
                                        value={patientData.nurse1?.nurseName || ''}
                                        onChange={(e) => handleValueChange('nurse1.nurseName', e.target.value)}
                                        className={`${inputClasses} ${!isModify ? styleDisabled : ''}`}
                                        maxLength={40}
                                        disabled={!isModify}
                                    />
                                </div>
                                <div className="mb-[18px]">
                                    <label className={`${labelClasses}`}>{`${t('bedSetting.nurse')} 1 - ${t('bedSetting.phoneNumber')}`}</label>
                                    <input
                                        type="text"
                                        value={patientData.nurse1?.nursePhoneNumber || ''}
                                        onChange={(e) => handleValueChange('nurse1.nursePhoneNumber', e.target.value)}
                                        className={`${inputClasses} ${!isModify ? styleDisabled : ''}`}
                                        maxLength={20}
                                        disabled={!isModify}
                                    />
                                </div>
                            </div>
                            <div className="flex gap-[16px]">
                                <div className="mb-[18px]">
                                    <label className={`${labelClasses}`}>{`${t('bedSetting.nurse')} 2`}</label>
                                    <input
                                        type="text"
                                        value={patientData.nurse2?.nurseName || ''}
                                        onChange={(e) => handleValueChange('nurse2.nurseName', e.target.value)}
                                        className={`${inputClasses} ${!isModify ? styleDisabled : ''}`}
                                        maxLength={40}
                                        disabled={!isModify}
                                    />
                                </div>
                                <div className="mb-[18px]">
                                    <label className={`${labelClasses}`}>{`${t('bedSetting.nurse')} 2 - ${t('bedSetting.phoneNumber')}`}</label>
                                    <input
                                        type="text"
                                        value={patientData.nurse2?.nursePhoneNumber || ''}
                                        onChange={(e) => handleValueChange('nurse2.nursePhoneNumber', e.target.value)}
                                        className={`${inputClasses} ${!isModify ? styleDisabled : ''}`}
                                        maxLength={20}
                                        disabled={!isModify}
                                    />
                                </div>
                            </div>
                            <div className="flex gap-[16px]">
                                <div className="mb-[18px]">
                                    <label className={`${labelClasses}`}>{`${t('bedSetting.nurse')} 3`}</label>
                                    <input
                                        type="text"
                                        value={patientData.nurse3?.nurseName || ''}
                                        onChange={(e) => handleValueChange('nurse3.nurseName', e.target.value)}
                                        className={`${inputClasses} ${!isModify ? styleDisabled : ''}`}
                                        maxLength={40}
                                        disabled={!isModify}
                                    />
                                </div>
                                <div className="mb-[18px]">
                                    <label className={`${labelClasses}`}>{`${t('bedSetting.nurse')} 3 - ${t('bedSetting.phoneNumber')}`}</label>
                                    <input
                                        type="text"
                                        value={patientData.nurse3?.nursePhoneNumber || ''}
                                        onChange={(e) => handleValueChange('nurse3.nursePhoneNumber', e.target.value)}
                                        className={`${inputClasses} ${!isModify ? styleDisabled : ''}`}
                                        maxLength={20}
                                        disabled={!isModify}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="h-[448px] pl-[40px]">
                            <div className="flex text-[#DEDEDE] box-border bg-[#2F2F2F] rounded-[8px ]">
                                <div className="h-[448px] min-w-[278px] px-[16px] py-[14px]">
                                    <h2 className="text-lg mb-[16px] font-normal text-white">{t('bedSetting.patientStatus')}</h2>
                                    <div className="gap-[16px]">
                                        <div className="mb-[20px]">                                            
                                            <label className={`${labelClasses} !mb-[0px] flex justify-between items-center`}>{t('bedSetting.admissionStatus')}                                                
                                                <span className={`flex items-center h-[20px] bg-[#1F1F1F] px-[3px] pl-[8px] pr-[8px] gap-[6px] rounded-[12px] before:content-[''] before:inline-block before:w-[10px] before:h-[10px] before:rounded-[13px] 
                                                    ${isAdmit ? 'before:bg-[#3182F7]' : 'before:bg-[#FFF500]'}`}>
                                                    {isAdmit ? t('bedSetting.admitted') : t('bedSetting.notAdmitted')}
                                                </span>
                                            </label>
                                            {
                                                isModify && 
                                                    <button className={`w-[278px] h-[28px] rounded-[6px] font-light mt-[10px]
                                                            ${isAdmit ? ' text-white border border-[#5E5E5E] bg-gradient-to-b from-[#5E5E5E] to-[#383838] shadow-md transition-all duration-200'
                                                            : 'bg-[#282828] text-[rgba(255,255,255,0.2)] cursor-default shadow-none'}
                                                            active:from-[#4A4A4A] active:to-[#2B2B2B] active:shadow-sm`}
                                                            disabled={!isAdmit}
                                                            onClick={() => { handleDisChargeConfirm()}}>
                                                        {t('bedSetting.discharge')}
                                                    </button>
                                            }                                            
                                            <button className={`w-[278px] h-[28px] rounded-[6px] font-light mt-[10px]
                                                    ${isAdmit ? ' text-white border border-[#5E5E5E] bg-gradient-to-b from-[#5E5E5E] to-[#383838] shadow-md transition-all duration-200'
                                                    : 'bg-[#282828] text-[rgba(255,255,255,0.2)] cursor-default shadow-none'}
                                                    active:from-[#4A4A4A] active:to-[#2B2B2B] active:shadow-sm`}
                                                    disabled={!isAdmit}
                                                    onClick={() => { handleTransferConfirm()}}>
                                                {t('bedSetting.transfer')}
                                            </button>   
                                        </div>   
                                        {
                                            isModify && standbyModeRef.current && (
                                                <div>
                                                    <label className={`${labelClasses}`}>{t('bedSetting.standbyMode')}</label>
                                                    <button className={`w-[278px] h-[28px] rounded-[6px] font-light
                                                            text-white border border-[#5E5E5E] bg-gradient-to-b from-[#5E5E5E] to-[#383838] shadow-md transition-all duration-200
                                                            active:from-[#4A4A4A] active:to-[#2B2B2B] active:shadow-sm`}
                                                            onClick={() => { handleSetStandby()}}>
                                                        {t('bedSetting.apply')}
                                                    </button>
                                                </div>
                                            )
                                        }
                                    </div>                            
                                </div>
                            </div>
                        </div>
                    </div>                    
                    {
                        isAdmit ? (
                            <button className={`w-[88px] h-[28px] absolute top-[-35px] right-[20px] rounded-[6px] font-light
                                    ${(isDisabled || !isModify) ? 'bg-[#282828] text-[rgba(255,255,255,0.2)] cursor-default shadow-none'
                                    : ' text-white bg-gradient-to-b from-[#5E5E5E] to-[#383838] shadow-md transition-all duration-200'}
                                    active:from-[#4A4A4A] active:to-[#2B2B2B] active:shadow-sm`}
                                disabled={isDisabled || !isModify}
                                onClick={() => handleSave('modify')}
                                >{(isDisabled || !isModify) ? t('bedSetting.saved') : t('bedSetting.save')}
                            </button>
                        ) : (
                            <button className={`w-[88px] h-[28px] absolute top-[-35px] right-[20px] rounded-[6px] font-light                            
                                    ${!isModify ? 'bg-[#282828] text-[rgba(255,255,255,0.2)] cursor-default shadow-none'
                                    : 'text-white bg-gradient-to-b from-[#5E5E5E] to-[#383838] shadow-md transition-all duration-200'}
                                    active:from-[#4A4A4A] active:to-[#2B2B2B] active:shadow-sm`}
                                disabled={!isModify}
                                onClick={() => {handleAdmitConfirm()}}
                                >{t('bedSetting.admit')}
                            </button>
                        )
                    }
                </div>
            </div>

            
        </div>
    );
}

export default PatientInfoSettings;